import { apiDelete, apiGet, apiPost, apiUpdate } from "../http";

export default {
  async logInAPI(data) {
    return await apiPost("api/login", data);
  },
  async getUsersAPI() {
    return await apiGet("api/users");
  },
  async getPermissionsAPI() {
    return await apiGet("api/permissions");
  },
  async deleteUserAPI(id) {
    return await apiDelete("api/user/" + id);
  },
  async editUserAPI(data) {
    return apiUpdate("api/user/" + data.id, data.data);
  },
  async createUserAPI(data) {
    return await apiPost("api/user", data);
  },
  async getWarehouseKPIAPI() {
    return await apiGet("api/warehouseKPI");
  },
  async getSEKPI_API() {
    return await apiGet("api/sellerExperienceKPI");
  },
  async getCustomKPI_API(data) {
    return await apiPost("api/customKPI", data);
  },
  async getKPI_API(data){
    return await apiPost("api/KPI", data)
  }
};
